import React, {useState, useRef, useEffect} from 'react';
import $ from 'jquery';
import { useDispatch } from 'react-redux';
import * as R from 'ramda';

import {updateDeathDeclaration} from '../../../../actions/facilita-api';
import * as loadings from '../../../../constants/loadings/facilita/deathDeclaration';

import {CivilForm} from './civilForm';
import {FamilySituationForm} from './familySituationForm';
import {ChildrenForm} from './childrenForm';
import {ResidenceForm} from './residenceForm';
import {ProfessionalSituationForm} from './professionalSituationForm';
import {ToasterConfigurations} from '../../../../constants/toasterText/configurations';
import { toast } from 'react-toastify';


export const DossierProfile = ({userInfo, userId, isLoading}) => {
	const dispatch = useDispatch();
	const [personalData, setPersonalData] = useState({...userInfo});
	useEffect(() => {
		setPersonalData({...userInfo})
	}, [userInfo])

	if(R.isNil(personalData) || R.isEmpty(personalData)){
		return '';
	}

	

	return (
		<article className="view-calc pt-4 mb-auto">
			<div className="auto-view py-3 pb-lg-0">
				<div className="container-fluid">
				<CivilForm personalData={personalData} setPersonalData={setPersonalData} />
				<FamilySituationForm personalData={personalData} setPersonalData={setPersonalData} />
				<ChildrenForm personalData={personalData} setPersonalData={setPersonalData} isLoading={isLoading} />
				<ResidenceForm personalData={personalData} setPersonalData={setPersonalData} />
				<ProfessionalSituationForm personalData={personalData} setPersonalData={setPersonalData} />				
				</div>
			</div>
			<div className="container-fluid">
				<footer className="flex-md-row align-items-center mt-auto mb-sm w-100">
					{
						isLoading.includes(loadings.UPDATING_DECLARATION) ? 
							<button type="button" className="btn btn-info loading-btn show">Sauvegarder<div className="loading loading-spinner spinner-border spinner-border-sm ml-2 mr-n1"></div></button>
						:
							<button className={"btn btn-info loading-btn"}
							onClick={(event) => {
								event.preventDefault();
								dispatch(updateDeathDeclaration(userId, personalData))
								.then(() => toast.success("Les données ont été mises à jour.", ToasterConfigurations))
								.catch(() => toast.error("Une erreur est survenue.", ToasterConfigurations))
							}}>Sauvegarder<div className="loading loading-spinner spinner-border spinner-border-sm ml-2 mr-n1"></div></button>
					}
					
					<h6 className="my-3 my-md-0 mr-auto order-lg-first fs-3 o-60">* champs obligatoires</h6>
				</footer>
			</div>
		</article>
	)
}